export default {
  data() {
    return {
      $_timelineCanvasElement: undefined,
      $_timelineCanvasContext: undefined,
      $_timelineCanvasWidthPx: undefined,
      $_timelineCanvasHeightPx: undefined,
      $_timelineCanvasResizeObserver: new ResizeObserver(this.$_updateTimelineCanvasSize),
      $_isDirty: false,
      $_isDrawing: false,
      $_isDrawSkipped: false,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.$data.$_timelineCanvasElement = this.$el;
      this.$data.$_timelineCanvasContext = this.$data.$_timelineCanvasElement.getContext('2d');
      this.$data.$_timelineCanvasResizeObserver.observe(this.$data.$_timelineCanvasElement);
      this.$_updateTimelineCanvasSize();
    });
  },

  destroyed() {
    this.$data.$_timelineCanvasResizeObserver.disconnect();
  },

  methods: {
    $_updateTimelineCanvasSize() {
      let timelineCanvasWidthPx = this.$data.$_timelineCanvasElement.clientWidth;
      let timelineCanvasHeightPx = this.$data.$_timelineCanvasElement.clientHeight;
      this.$data.$_timelineCanvasElement.width = timelineCanvasWidthPx;
      this.$data.$_timelineCanvasElement.height = timelineCanvasHeightPx;
      this.$data.$_timelineCanvasWidthPx = timelineCanvasWidthPx;
      this.$data.$_timelineCanvasHeightPx = timelineCanvasHeightPx;
      this.$_setDirty(true);
    },

    $_setDirty(isDirty) {
      this.$data.$_isDirty = isDirty;
    },

    $_draw(callback) {
      if (this.$data.$_timelineCanvasContext === undefined) return;
      if (!this.$data.$_isDrawing) {
        this.$data.$_isDrawing = true;
        if (this.$data.$_isDirty || this.$data.$_isDrawSkipped) {
          this.$data.$_timelineCanvasContext.clearRect(
            0,
            0,
            this.$data.$_timelineCanvasWidthPx,
            this.$data.$_timelineCanvasHeightPx,
          );
          callback();
          this.$data.$_isDirty = false;
          this.$data.$_isDrawSkipped = false;
        }
        this.$data.$_isDrawing = false;
      } else {
        this.$data.$_isDrawSkipped = true;
      }
    },
  },
}
